module.exports = __webpack_public_path__ + "static/sheila-photo-a0a366d8645b5ccae28c3ef5c4f1d09a.jpg";